import client from "@https/api";
import noVersionClient from "@https/no-version-api";
import gate from "gate/gate";
import api from "gate/gate";
import {
  IFestivalBanner,
  IGuestSessionInput,
  IGuestSessionOutput,
  StaticLayoutDT,
  UserLayoutDataDT,
  UserSubscriptionDT,
} from "types/api/layout";
import {
  FAVORITE_TYPE,
  IFavoriteData,
  IFavoriteMessageInput,
  IFooterInput,
  IHomeCardsInput,
  IHomeHowToLearn,
  IHomeHowToLearnData,
  IMegamenuInput,
  INoticeInput,
  OHomeCardsOutput,
  OHomeHowToLearnOutput,
  ONewsletterOutput,
} from "./types";
import { PRODUCT_SLUG } from "@types";

const homeApi = {
  getStaticLayout: () =>
    api.get<StaticLayoutDT, never, never>({
      client,
      url: "/static",
    }),
  getUserLayoutData: () =>
    api.get<UserLayoutDataDT, never, never>({
      client,
      url: "/user/overview",
    }),
  getUserSubscriptionData: () =>
    gate.get<UserSubscriptionDT, never, never>({
      client,
      url: "/subscription/status",
    }),
  addFavoriteProduct: (
    productId: number,
    type: FAVORITE_TYPE = FAVORITE_TYPE.PRODUCT
  ) =>
    gate.put<IFavoriteMessageInput, IFavoriteData, { type: FAVORITE_TYPE }>({
      client,
      data: { id: productId, type: type },
      params: { type },
      url: `/product/${productId}/favorite`,
    }),
  removeFavoriteProduct: (
    productId: number,
    type: FAVORITE_TYPE = FAVORITE_TYPE.PRODUCT
  ) =>
    gate.delete<IFavoriteMessageInput, never, { type: FAVORITE_TYPE }>({
      client,
      params: { type },
      url: `/product/${productId}/favorite`,
    }),

  news: (params: ONewsletterOutput) =>
    api.post<IFavoriteMessageInput, never, ONewsletterOutput>({
      client,
      params: params,
      url: `/newsletter`,
    }),
  getFooter: () =>
    api.get<IFooterInput, never, never>({
      client,
      url: "/footer",
    }),
  checkNotice: (page: string) =>
    api.get<INoticeInput, never, never>({
      client,
      url: `/notices/${page}`,
    }),
  getMegamenu: () =>
    api.get<IMegamenuInput, never, never>({
      client,
      url: "/megaMenu",
    }),
  getHomeCards: (name: PRODUCT_SLUG, params?: OHomeCardsOutput) =>
    api.get<IHomeCardsInput, never, OHomeCardsOutput>({
      client,
      url: `/home/cards/${name}`,
      params,
    }),
  getHowToLearn: (params?: OHomeHowToLearnOutput) =>
    api.get<
      IHomeHowToLearn<{ how_to_learn: IHomeHowToLearnData[] }>,
      never,
      OHomeHowToLearnOutput
    >({
      client,
      url: "/home/howToLearn",
      params,
    }),

  getFestivalBanner: () =>
    gate.get<IFestivalBanner, never, never>({
      client,
      url: "/homepage/top-banner",
    }),

  postToGetGuestSession: (payload: IGuestSessionInput) =>
    gate.post<IGuestSessionOutput, unknown, unknown>({
      client: noVersionClient,
      url: "/py",
      params: {
        path: "/users/guest/create",
        strict: 1,
      },
      data: payload,
    }),
};

export default homeApi;
